import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
    <svg fill="none" viewBox="0 0 20 15">
        <circle cx="11.5" cy="7.5" r="6" stroke="#B0B0B0" />
        <circle cx="8.5" cy="7.5" r="6" stroke="#B0B0B0" />
    </svg>,
    "StereoOff",
);
